import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { bool, func, shape, string } from 'prop-types';
import { eventNames, reportToSegment, types } from '@smartcar/morse';

import { InputField } from '../../../../../../components';
import staticText from '../../../../../../localization/Authentication/userSecurity';

const MfaChallengeInput = ({
  verifyCallback,
  mfaInProgress,
  mfaObj,
  mfaError,
  mfaEnabled,
  mfaSaveFactorId,
  cancelChallenge,
}) => {
  const [challengeSubmitted, setChallengeSubmitted] = useState(false);
  const [mfaCode, setMfaCode] = useState('');

  const handleChange = (e) => {
    setChallengeSubmitted(false);
    setMfaCode(e.target.value.replace(/\D/g, ''));
  };

  const verifyChallengeCode = (e) => {
    e.preventDefault();
    const verifyObj = {
      challengeId: mfaObj.challengeId,
      code: mfaCode,
      factorId: mfaObj.factorId,
      mfaSaveFactorId,
    };

    setChallengeSubmitted(true);
    reportToSegment(types.TRACK, eventNames.buttonClicked, { label: 'backend action', text: 'Verifying MFA passcode' });

    verifyCallback(verifyObj);
  };

  return (
    <Box marginTop={3}>
      <form onSubmit={verifyChallengeCode}>
        <Typography sx={{ marginBottom: 1 }}>
          {mfaEnabled ? staticText.mfaSetup.disableMfaDescription : staticText.mfaSetup.enterCode}
        </Typography>
        <InputField
          id="code"
          inputName="code"
          inputValues={mfaCode}
          inputPlaceholder={staticText.mfaChallenge.codeInputPlaceholder}
          handleChange={handleChange}
          required
          InputProps={{
            autoComplete: 'one-time-code',
            inputMode: 'numeric',
          }}
          errorMessage={!mfaInProgress && challengeSubmitted && mfaError}
        />
        <Box display="flex" gap={1} marginTop={3}>
          <Button
            id="confirmChallengeMFA"
            variant="outlined"
            type="submit"
            disabled={!mfaCode || mfaInProgress}
          >
            {staticText.mfaSetup.verify}
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={cancelChallenge}
          >{staticText.mfaSetup.cancel}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default MfaChallengeInput;

MfaChallengeInput.propTypes = {
  verifyCallback: func.isRequired,
  mfaObj: shape({
    challengeId: string,
    factorId: string,
    qrCode: string,
    secretKey: string,
  }),
  mfaEnabled: bool.isRequired,
  mfaInProgress: bool.isRequired,
  mfaError: string,
  mfaSaveFactorId: bool,
  cancelChallenge: func.isRequired,
};

MfaChallengeInput.defaultProps = {
  mfaError: '',
  mfaObj: {
    challengeId: null,
    factorId: null,
    qrCode: null,
    secretKey: null,
  },
  mfaSaveFactorId: false,
};

